import axios from 'axios';
import { axiosInstance } from './api';
import { API_BASE } from './base';

interface LoginResponse {
  access: string;
  refresh?: string;
}

export const login = (username: string, password: string) =>
  axiosInstance.post<LoginResponse>('/core/api/auth/jwt/create/', { username, password });

export interface TelegramWidgetUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  photo_url?: string;
  auth_date: number;
  hash: string;
}

export const telegramLogin = (data: TelegramWidgetUser, inviteToken?: string) =>
  axiosInstance.post<LoginResponse>(
    '/core/api/auth/tg-login/',
    inviteToken ? { ...data, invite_token: inviteToken } : data,
  );

export const exchangeTelegramToken = (tgToken: string) =>
  axiosInstance.post<LoginResponse>('/core/api/auth/tg-exchange/', { tg_token: tgToken });

export const exchangeTelegramMiniAppInitData = (payload: {
  init_data: string;
  /** Same role as exchangeTelegramOidcCode's invite_token — when the
   *  Mini App was opened via `t.me/<bot>/app?startapp=invite_<token>`,
   *  this is that token. The BE uses it to bootstrap a Django user
   *  from the TG identity for accounts that have no operator-set
   *  binding yet. */
  invite_token?: string;
}) =>
  axiosInstance.post<LoginResponse>('/core/api/auth/tg-miniapp/', payload);

export const exchangeTelegramOidcCode = (payload: {
  code: string;
  code_verifier: string;
  redirect_uri: string;
  /** When the user kicked off OIDC from /auth?next=/invite/<token>,
   *  this is that token. The BE uses it as authorization to create
   *  a fresh Django user from the TG identity (otherwise unbound
   *  TG users get 403 — see tg_oidc.py). */
  invite_token?: string;
}) =>
  axiosInstance.post<LoginResponse>('/core/api/auth/tg-oidc/exchange/', payload);

// Bypasses axiosInstance to avoid the 401 interceptor recursing on refresh failure.
export const refreshAccessToken = (refresh: string) =>
  axios.post<{ access: string }>(
    `${API_BASE}/core/api/auth/jwt/refresh/`,
    { refresh },
    { timeout: 30000 },
  );
